import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63117096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = {
  key: 0,
  class: "mb-x5 flex w-full"
}
const _hoisted_3 = {
  key: 0,
  class: "aspect-square w-full"
}

import { ImageFileModel, ProductTransparencyTileModel } from '@/types/B2CcontentServerContract';
import TransparencySwipable from '@/shared/content/blocks/transparency/TransparencySwipable.vue';
import useProductDetailData from '@/shared/product/details/useProductDetailData';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTransparencyTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content?: ProductTransparencyTileModel
}



const { transparencyData } = useProductDetailData();

const image = props.content?.fillerImage?.model as ImageFileModel;

return (_ctx: any,_cache: any) => {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!
  const _component_Breakpoints = _resolveComponent("Breakpoints")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(transparencyData))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Breakpoints, null, {
            "min-md": _withCtx(() => [
              (_unref(image))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_unref(image).url)
                      ? (_openBlock(), _createBlock(_component_ResponsiveImage, {
                          key: 0,
                          class: "w-full h-full",
                          "aria-hidden": "true",
                          mode: "cover",
                          "image-url": _unref(image).url,
                          "aspect-ratio": 1/1,
                          "width-on-screen": 50,
                          "focus-points": _unref(image).focusPoints,
                          focus: _unref(image).focus,
                          zoom: _unref(image).zoom,
                          alt: _unref(image).description,
                          "bg-color": _unref(image).hexCode,
                          flip: _unref(image).flip,
                          "cache-bust": _unref(image).cachebust
                        }, null, 8, ["image-url", "focus-points", "focus", "zoom", "alt", "bg-color", "flip", "cache-bust"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(image))
                ? (_openBlock(), _createBlock(TransparencySwipable, {
                    key: 1,
                    categories: _unref(transparencyData).categories,
                    "container-width": "50vw",
                    "step-width": "44vw",
                    "show-navigation": ""
                  }, null, 8, ["categories"]))
                : (_openBlock(), _createBlock(TransparencySwipable, {
                    key: 2,
                    categories: _unref(transparencyData).categories
                  }, null, 8, ["categories"]))
            ]),
            "max-sm": _withCtx(() => [
              _createVNode(TransparencySwipable, {
                categories: _unref(transparencyData).categories
              }, null, 8, ["categories"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})